import { useEffect, useState } from "react";

const SpeedControls=({speedOptions, selectedSpeed, speedValFunc, mediaPlayerRef})=>{
    const [currentSpeed,setCurrentSpeed]=useState(Number(selectedSpeed));
    const [rangeSliderVal,setRangeSliderVal]=useState(100);

    const step = 0.05; // Step for increase/decrease
    const minSpeed = 0.25, maxSpeed = 2; // Limits

    const updateSpeed=(newSpeed)=>{
        const newSpeedVal=Number(newSpeed);
        setRangeSliderVal(newSpeedVal*100);
        setCurrentSpeed(newSpeedVal);
        speedValFunc(newSpeedVal);
        if (mediaPlayerRef.current) {
            mediaPlayerRef.current.playbackRate = parseFloat(newSpeedVal);
        }
    }

    const handleSpeedChange=(event)=>{
        const newSpeed=parseFloat((Number(event.target.value)).toFixed(2));
        updateSpeed(newSpeed);
    }

    const handleSpeedSlider=(event)=>{
        const newSpeed=parseFloat((Number(event.target.value)/100).toFixed(2));
        updateSpeed(newSpeed);
    }

    const handleSpeedDecrease=()=>{
        if (currentSpeed > minSpeed) {
            const newSpeed = Math.max(currentSpeed - step, minSpeed); // Ensure min limit
            updateSpeed(parseFloat(newSpeed).toFixed(2));
        }
    }

    const handleSpeedIncrease=()=>{
        if (currentSpeed < maxSpeed) {
            const newSpeed = Math.min(currentSpeed + step, maxSpeed); // Ensure max limit
            updateSpeed(parseFloat(newSpeed).toFixed(2));
        }
    }

    useEffect(()=>{
        updateSpeed(currentSpeed);
    },[]);

    return (
        <div className="speed-dropdown-react p-2 text-white">
            <span className="">Preset Speeds:</span>
            <div className="flex gap-3 flex-wrap mt-6">
                {
                    speedOptions.map((speed) => (
                        <div key={speed.value} className="flex items-center">
                            <input
                                type="radio"
                                id={`speed-${speed.value}`}
                                value={speed.value}
                                name="speed"
                                className="hidden speed-radio"
                                checked={currentSpeed.toString() === speed.value}
                                onChange={handleSpeedChange}
                            />
                            <label
                                htmlFor={`speed-${speed.value}`}
                                className="ml-2 text-sm font-medium grow"
                            >
                                {speed.label}
                            </label>
                        </div>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center mt-6">
                <span className="">Custom Speed:</span>
                <span id="media-speed-label" className="min-w-10">{currentSpeed}x</span>
                <button id="decrease-speed-btn" className="" onClick={handleSpeedDecrease}>-</button>
                <button id="increase-speed-btn" className="" onClick={handleSpeedIncrease}>+</button>
            </div>

            <div className="mt-4 w-full">
                <input id="media-speed-slider" type="range" min="25" max="200" value={rangeSliderVal} onChange={handleSpeedSlider} className="w-full h-1 accent-deep-red rounded-lg cursor-pointer"/>
            </div>
        </div>
    )
}

export default SpeedControls;